export default __webpack_public_path__ + "b55f2742c8bbc355f6e30f118d32fbab.svg";